import type { ReactNode } from 'react';

/** DESIGN.md §9.1 VisuallyHidden — content for assistive tech only, removed from visual flow
 * without `display: none` (which would remove it from the accessibility tree too). */
export function VisuallyHidden({ children }: { children: ReactNode }) {
  return <span className="visually-hidden">{children}</span>;
}
